var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpp20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "138.64209mm",
    height: "69.149719mm",
    viewBox: "0 0 138.64209 69.149719",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 365.49408,
    height: 246.96031,
    id: "rect34245-5-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    transform: "translate(-921.82729,-16.360012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer14",
    transform: "translate(2.80633,9.5415221)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      display: "inline",
      fill: "#aeaeae",
      fillOpacity: 1,
      stroke: "#aeaeae",
      strokeWidth: 3.175,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "path43296",
    d: "M 37.469266,68.923959 8.9264855,52.480254 8.8957609,19.539629 37.407817,3.0427084 l 28.54278,16.4437046 0.03073,32.940625 z",
    transform: "translate(911.71266,5.3632577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43309",
    style: {
      fontVariationSettings: "normal",
      display: "inline",
      fill: "#3f4444",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 3.175,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "m 977.80365,24.982958 -57.10328,33.01142 28.4815,16.38635 28.74581,-16.49667 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 10.5833,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    id: "path47118",
    r: 16.453457,
    cy: 41.739311,
    cx: 949.54669
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44382",
    style: {
      fontVariationSettings: "normal",
      display: "inline",
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#8c8c8c",
      strokeWidth: 3.175,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    d: "m 977.87004,24.850408 -28.26546,16.31063 28.35434,16.6331 z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "7.05556px",
      fontVariationSettings: "normal",
      letterSpacing: "2.64583px",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#8c8c8c",
      strokeWidth: 2.11667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    x: 961.71753,
    y: 43.459084,
    id: "text46898"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan46896",
    style: {
      fontSize: "7.05556px",
      stroke: "#ffffff",
      strokeWidth: 2.11667,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 961.71753,
    y: 43.459084
  }, "++")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,969.81463,-64.001292)",
    id: "text34243-7-4",
    style: {
      fontSize: 200,
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect34245-5-2)",
      shapePadding: 8.48528,
      display: "inline",
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#3f4444",
      strokeWidth: 25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 68.412109,
    y: 467.60669,
    id: "tspan46765"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#ffffff",
      stroke: "#f8f9f9"
    },
    id: "tspan46763"
  }, "20"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpp20);
export default __webpack_public_path__ + "static/media/Cpp20.381530519214560618468c20c3916ce1.svg";
export { ForwardRef as ReactComponent };